/**
 * AgeMate Custom Cart Drawer v8
 * - Same as v7 but with:
 *   - Welcome kit image fallback (no more black squares)
 *   - sessionStorage cart cache (instant open, no loading flash)
 *   - Optimistic line item on Add to Cart (drawer never appears empty)
 * - Gift logic, rendering, UI: all UNCHANGED from v7
 */

(function () {
  'use strict';

  const CONFIG = {
    singleSub: [44372896579824, 49560130420976, 45885826662640],
    doubleSub: [44372896612592, 49560130453744, 45885826695408],
    oneTime:   [44372896547056, 49560130486512, 45885826728176],
    kits: {
      auEx: { single: 47917130449136, double: 47917130350832 },
      nr:   { single: 47917130186992, double: 47917130088688 }
    },
    shaker: 44377485803760,
    allGiftIds: [47917130449136, 47917130350832, 47917130186992, 47917130088688, 44377485803760],
    maxSingleSub: 3,
    maxDoubleSub: 2,
    maxTotalSub: 4,
otpToSingleSub: {
      44372896547056: 44372896579824,
      49560130486512: 49560130420976,
      45885826728176: 45885826662640
    },
    variantToSellingPlan: {
      44372896579824: 4999184624, 44372896612592: 4999184624,   // AU
      49560130420976: 7546732784, 49560130453744: 7546732784,   // EX (NZ/SG)
      45885826662640: 5302518000, 45885826695408: 5302518000    // NR (US/UK)
    },
    auFreeShippingCents: 10000,
    // Fallback images (used when item.image is null/missing)
    fallbackImages: {
      singleKit: 'https://cdn.shopify.com/s/files/1/0651/0346/2640/files/AgeMate-Welcome-Pack-Container-Bottle-BlueBG.jpg?v=1700007879',
      doubleKit: 'https://cdn.shopify.com/s/files/1/0651/0346/2640/files/AgeMate-Welcome-Pack-Double-Container-Bottle-BlueBG.jpg?v=1700008306',
      shaker: 'https://cdn.shopify.com/s/files/1/0651/0346/2640/files/AgeMate-Drink-Bottle-BlueBG.jpg?v=1700007749'
    }
  };

  // sessionStorage cache key
  const CACHE_KEY = 'am_cart_v8';

  const productPriceCache = {};

  let cart = null;
  let isUpdating = false;
  let isOpen = false;
  let addingFromUs = false;
  let drawerReadyResolve = null;

  const $ = (sel) => document.querySelector(sel);
  const drawer = $('#am-cart-drawer');
  const overlay = $('#am-cart-overlay');
  const closeBtn = $('#am-cart-close');
  const continueBtn = $('#am-cart-continue');
  const body = document.body;

  const emptyEl = $('#am-cart-empty');
  const itemsEl = $('#am-cart-items');
  const subSection = $('#am-cart-sub-section');
  const otpSection = $('#am-cart-otp-section');
  const giftsSection = $('#am-cart-gifts-section');
  const giftsDivider = $('#am-cart-gifts-divider');
  const subItems = $('#am-cart-sub-items');
  const otpItems = $('#am-cart-otp-items');
  const giftItems = $('#am-cart-gift-items');
  const clearWrap = $('#am-cart-clear-wrap');
  const clearBtn = $('#am-cart-clear');
  const footerEl = $('#am-cart-footer');
  const subtotalEl = $('#am-cart-subtotal');
  const checkoutForm = $('#am-cart-checkout-form');
  const checkoutBtn = checkoutForm ? checkoutForm.querySelector('button, [type="submit"], a') : null;
  const promoToggle = $('#am-cart-promo-toggle');
  const promoForm = $('#am-cart-promo-form');
  const promoInput = $('#am-cart-promo-input');
  const promoApply = $('#am-cart-promo-apply');
  const promoMsg = $('#am-cart-promo-msg');
  const promoDefault = $('#am-cart-promo-default');
  const promoApplied = $('#am-cart-promo-applied');
  const promoPillCode = $('#am-cart-promo-pill-code');
  const promoPillAmount = $('#am-cart-promo-pill-amount');
  const shippingBar = $('#am-cart-shipping-bar');
  const shippingMsg = $('#am-cart-shipping-msg');
  const shippingFill = $('#am-cart-shipping-fill');
  const upsellSub = $('#am-cart-upsell-sub');
  const upsellSubMsg = $('#am-cart-upsell-sub-msg');
  const upsellSubBtn = $('#am-cart-upsell-sub-btn');

  /* =========================================
     HELPERS
     ========================================= */

  function isSingleSub(v) { return CONFIG.singleSub.includes(v); }
  function isDoubleSub(v) { return CONFIG.doubleSub.includes(v); }
  function isOneTime(v) { return CONFIG.oneTime.includes(v); }
  function isSubscription(v) { return isSingleSub(v) || isDoubleSub(v); }
  function isGift(v) { return CONFIG.allGiftIds.includes(v); }
  function isProduct(v) { return isSingleSub(v) || isDoubleSub(v) || isOneTime(v); }
  function isWelcomeKit(v) {
    return v === CONFIG.kits.auEx.single || v === CONFIG.kits.auEx.double ||
           v === CONFIG.kits.nr.single || v === CONFIG.kits.nr.double;
  }
  function isShaker(v) { return v === CONFIG.shaker; }

  function getMarketForVariant(vid) {
    if (CONFIG.singleSub[2] === vid || CONFIG.doubleSub[2] === vid || CONFIG.oneTime[2] === vid) return 'nr';
    return 'auEx';
  }

  function isAuMarket() {
    if (window.Shopify?.country === 'AU') return true;
    if (window.Shopify?.currency?.active === 'AUD') return true;
    return false;
  }

  function detectMarket(items) {
    for (const item of items) {
      if (getMarketForVariant(item.variant_id) === 'nr') return 'nr';
    }
    return 'auEx';
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    if (window.Shopify?.currency?.active) {
      const code = window.Shopify.currency.active;
      const symbol = { AUD: '$', NZD: '$', SGD: '$', GBP: '£', USD: '$' }[code] || '$';
      return `${symbol}${amount} ${code}`;
    }
    return `$${amount}`;
  }

  function getGiftForVariant(variantId) {
    if (isOneTime(variantId)) return null;
    const market = getMarketForVariant(variantId);
    const kits = CONFIG.kits[market];
    if (isSingleSub(variantId)) return kits.single;
    if (isDoubleSub(variantId)) return kits.double;
    return null;
  }

  function getProductHandle(item) {
    if (item.url) {
      const match = item.url.match(/\/products\/([^?]+)/);
      if (match) return match[1];
    }
    return null;
  }

  function getProductUrl(item) {
    const handle = getProductHandle(item);
    return handle ? `/products/${handle}` : '#';
  }

  /* =========================================
     CACHE
     ========================================= */

  function getCachedCart() {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      // Expire after 10 minutes
      if (!data.timestamp || (Date.now() - data.timestamp) > 600000) return null;
      return data.cart;
    } catch (e) { return null; }
  }

  function setCachedCart(cartData) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ cart: cartData, timestamp: Date.now() }));
    } catch (e) {}
  }

  /* =========================================
     PRODUCT PRICE CACHE
     ========================================= */

  async function fetchProductPrices(item) {
    // Don't fetch prices for gift items — they're free
    if (isGift(item.variant_id)) return { otpPrice: null, singleSubPrice: null };

    const handle = getProductHandle(item);
    if (!handle) return { otpPrice: null, singleSubPrice: null };

    if (productPriceCache[handle] !== undefined) return productPriceCache[handle];

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      let otpPrice = null;
      let singleSubPrice = null;
      for (const v of product.variants) {
        if (CONFIG.oneTime.includes(v.id)) otpPrice = v.price;
        if (CONFIG.singleSub.includes(v.id)) singleSubPrice = v.price;
      }
      const result = { otpPrice, singleSubPrice };
      productPriceCache[handle] = result;
      return result;
    } catch (e) {
      productPriceCache[handle] = { otpPrice: null, singleSubPrice: null };
      return { otpPrice: null, singleSubPrice: null };
    }
  }

  async function fetchOneTimePrice(item) {
    const { otpPrice } = await fetchProductPrices(item);
    return otpPrice;
  }
  /* =========================================
     SELLING PLAN RESOLVER (cart fix)
     Maps a subscription variant to its selling_plan id,
     read from the product JSON's selling_plan_allocations.
     ========================================= */
  const sellingPlanCache = {};

async function getSellingPlanForVariant(variantId, handleHint) {
    if (!isSubscription(variantId)) return null;
    if (CONFIG.variantToSellingPlan[variantId]) return CONFIG.variantToSellingPlan[variantId];   // <-- new line
    if (sellingPlanCache[variantId] !== undefined) return sellingPlanCache[variantId];
    try {
      const handle = handleHint || 'daily-longevity-blend';
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      const product = await res.json();
      for (const v of product.variants) {
        const alloc = v.selling_plan_allocations && v.selling_plan_allocations[0];
        sellingPlanCache[v.id] = alloc
          ? (alloc.selling_plan_id || (alloc.selling_plan && alloc.selling_plan.id) || null)
          : null;
      }
    } catch (e) {
      sellingPlanCache[variantId] = null;
    }
    return sellingPlanCache[variantId] || null;
  }

  /* =========================================
     SHOPIFY CART API (with cache write-through)
     ========================================= */

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const data = await res.json();
    setCachedCart(data);
    return data;
  }

  async function addToCartApi(items) {
    addingFromUs = true;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    addingFromUs = false;
    return res.json();
  }

  async function changeItem(lineKey, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity })
    });
    return res.json();
  }

  async function updateCartItems(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    return res.json();
  }

  async function clearCartApi() {
    const res = await fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    });
    return res.json();
  }

  /* =========================================
     GIFT LOGIC (unchanged from v7)
     ========================================= */

  function computeDesiredGifts(cartItems) {
    const market = detectMarket(cartItems);
    const kits = CONFIG.kits[market] || CONFIG.kits.auEx;
    let singleSubQty = 0, doubleSubQty = 0;

    for (const item of cartItems) {
      if (isSingleSub(item.variant_id)) singleSubQty += item.quantity;
      if (isDoubleSub(item.variant_id)) doubleSubQty += item.quantity;
    }

    const totalServings = singleSubQty + (doubleSubQty * 2);

    const gifts = [];

    if (totalServings === 0) {
      // No subs - no gifts
    } else if (totalServings === 1) {
      gifts.push({ id: kits.single, quantity: 1 });
    } else if (totalServings >= 2) {
      gifts.push({ id: kits.double, quantity: 1 });
    }

    const merged = {};
    for (const g of gifts) merged[g.id] = (merged[g.id] || 0) + g.quantity;
    return merged;
  }

  async function syncGifts(cartData) {
    const desired = computeDesiredGifts(cartData.items);
    const currentGifts = {};
    for (const item of cartData.items) {
      if (isGift(item.variant_id)) {
        if (!currentGifts[item.variant_id]) currentGifts[item.variant_id] = { totalQty: 0, keys: [] };
        currentGifts[item.variant_id].totalQty += item.quantity;
        currentGifts[item.variant_id].keys.push(item.key);
      }
    }

    let correct = true;
    for (const vid of Object.keys(desired).map(Number)) {
      const cur = currentGifts[vid];
      if (!cur || cur.totalQty !== desired[vid] || cur.keys.length > 1) { correct = false; break; }
    }
    for (const vid of Object.keys(currentGifts).map(Number)) {
      if (!desired[vid]) { correct = false; break; }
    }
    if (correct) return null;

    const updates = {};
    for (const info of Object.values(currentGifts)) {
      for (const key of info.keys) updates[key] = 0;
    }
    if (Object.keys(updates).length > 0) await updateCartItems(updates);

    const toAdd = [];
    for (const [vid, qty] of Object.entries(desired)) {
      toAdd.push({ id: parseInt(vid), quantity: qty, properties: { '_gift': 'true' } });
    }
    if (toAdd.length > 0) await addToCartApi(toAdd);

    return await fetchCart();
  }

  /* =========================================
     RENDERING
     ========================================= */

  function getProductImageUrl(item) {
    if (item.image) return item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x200$1$2');
    // Fallback for gift items when image is missing
    const vid = item.variant_id;
    if (vid === CONFIG.kits.auEx.single || vid === CONFIG.kits.nr.single) {
      return CONFIG.fallbackImages.singleKit;
    }
    if (vid === CONFIG.kits.auEx.double || vid === CONFIG.kits.nr.double) {
      return CONFIG.fallbackImages.doubleKit;
    }
    if (vid === CONFIG.shaker) {
      return CONFIG.fallbackImages.shaker;
    }
    return 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" fill="%23f0f0f0"><rect width="76" height="76"/></svg>');
  }

  function getMaxQty(variantId) {
    if (isSingleSub(variantId)) return CONFIG.maxSingleSub;
    if (isDoubleSub(variantId)) return CONFIG.maxDoubleSub;
    return 99;
  }

  function renderProductItem(item, savingsPercent) {
    const maxQty = getMaxQty(item.variant_id);
    const atMax = item.quantity >= maxQty;
    const productUrl = getProductUrl(item);
    const isOptimistic = item._optimistic === true;

    let variantLabel = '';
    if (isDoubleSub(item.variant_id)) {
      const tubs = 2 * item.quantity;
      const serves = 60 * item.quantity;
      variantLabel = `${tubs} tubs / ${serves} serves`;
    } else if (isSingleSub(item.variant_id)) {
      const tubs = item.quantity;
      const serves = 30 * item.quantity;
      const tubLabel = tubs === 1 ? 'tub' : 'tubs';
      variantLabel = `${tubs} ${tubLabel} / ${serves} serves`;
    } else if (isOneTime(item.variant_id)) {
      variantLabel = 'One-Time Purchase';
    }

    const savingsHtml = savingsPercent > 0 && !isOptimistic
      ? `<span class="am-cart__line-savings">Saving ${savingsPercent}%</span>`
      : '';

    // Show "Adding..." instead of $0 while we wait for the API
    const priceHtml = isOptimistic
      ? `<span class="am-cart__line-price" style="opacity:0.5;font-weight:400;font-size:13px;">Adding...</span>`
      : `<span class="am-cart__line-price">${formatMoney(item.final_line_price)}</span>`;

    const trashIcon = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 6V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V6M19 6V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V6H19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    return `
      <div class="am-cart__line-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
        <a href="${productUrl}" class="am-cart__line-img-link" onclick="return false;" tabindex="-1">
          <img class="am-cart__line-img" src="${getProductImageUrl(item)}" alt="${item.product_title}" loading="lazy" />
        </a>
        <div class="am-cart__line-info">
          <a href="${productUrl}" class="am-cart__line-name-link" onclick="return false;" tabindex="-1">
            <p class="am-cart__line-name">${item.product_title}</p>
          </a>
          <p class="am-cart__line-variant">${variantLabel}</p>
          <div class="am-cart__line-price-row">
            ${priceHtml}
            ${savingsHtml}
          </div>
          <div class="am-cart__qty-wrap">
            <button type="button" class="am-cart__qty-btn is-remove" data-action="${item.quantity <= 1 ? 'remove' : 'decrease'}" data-key="${item.key}" data-variant-id="${item.variant_id}" ${isOptimistic ? 'disabled' : ''}>
              ${item.quantity <= 1 ? trashIcon : '<span style="font-size:18px;">−</span>'}
            </button>
            <span class="am-cart__qty-val">${item.quantity}</span>
            <button type="button" class="am-cart__qty-btn" data-action="increase" data-key="${item.key}" data-variant-id="${item.variant_id}" ${atMax || isOptimistic ? 'disabled' : ''}>
              <span style="font-size:18px;">+</span>
            </button>
          </div>
          <div class="am-cart__max-msg ${atMax ? 'is-visible' : ''}" data-max-msg="${item.variant_id}">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 8V12M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            Maximum QTY of ${maxQty} reached
          </div>
        </div>
      </div>
    `;
  }

  function getGiftDisplayInfo(variantId) {
    return {
      [CONFIG.kits.auEx.single]: { name: 'Free Welcome Kit', desc: 'Container & Drink Bottle' },
      [CONFIG.kits.auEx.double]: { name: 'Free Welcome Kit', desc: 'Container & 2 Drink Bottles' },
      [CONFIG.kits.nr.single]: { name: 'Free Welcome Kit', desc: 'Container & Drink Bottle' },
      [CONFIG.kits.nr.double]: { name: 'Free Welcome Kit', desc: 'Container & 2 Drink Bottles' },
      [CONFIG.shaker]: { name: 'Free Drink Bottle', desc: '400ml Drink Bottle' }
    }[variantId] || { name: 'Free Gift', desc: '' };
  }

  function renderGiftItem(item) {
    const info = getGiftDisplayInfo(item.variant_id);
    const qtyLabel = item.quantity > 1 ? ` × ${item.quantity}` : '';
    return `
      <div class="am-cart__gift-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
        <img class="am-cart__gift-img" src="${getProductImageUrl(item)}" alt="${info.name}" loading="lazy" />
        <div class="am-cart__gift-info">
          <p class="am-cart__gift-name">${info.name}${qtyLabel}</p>
          <p class="am-cart__gift-desc">${info.desc}</p>
        </div>
        <span class="am-cart__gift-pill">Free</span>
      </div>
    `;
  }

  /* =========================================
     PROMO + SHIPPING BAR + UPSELL (unchanged)
     ========================================= */

  function renderPromo(cartData) {
    if (!promoDefault || !promoApplied) return;
    const discounts = cartData.cart_level_discount_applications || [];
    const discountCode = discounts.find(d => d.type === 'discount_code');

    if (discountCode && cartData.total_discount > 0) {
      promoDefault.style.display = 'none';
      promoApplied.style.display = '';
      if (promoPillCode) promoPillCode.textContent = discountCode.title;
      if (promoPillAmount) promoPillAmount.textContent = `−${formatMoney(cartData.total_discount)}`;
    } else {
      promoDefault.style.display = '';
      promoApplied.style.display = 'none';
    }
  }

  function renderShippingBar(cartData) {
    const productItems = cartData.items.filter(i => isProduct(i.variant_id));
    if (productItems.length === 0) {
      shippingBar.style.display = 'none';
      return;
    }

    // Hide shipping bar while in optimistic state (we don't know real totals yet)
    if (isOptimisticState(cartData)) {
      shippingBar.style.display = 'none';
      return;
    }

    shippingBar.style.display = '';
    const hasSub = productItems.some(i => isSubscription(i.variant_id));
    const hasOtpOnly = !hasSub && productItems.some(i => isOneTime(i.variant_id));
    const isAu = isAuMarket();

    if (isAu) {
      const subtotal = cartData.total_price;
      const threshold = CONFIG.auFreeShippingCents;
      if (subtotal >= threshold) {
        shippingMsg.innerHTML = `You've earned free shipping. <strong>Perfect.</strong>`;
        shippingFill.style.width = '100%';
        shippingFill.classList.add('is-complete');
      } else {
        const remaining = (threshold - subtotal) / 100;
        const currency = window.Shopify?.currency?.active || 'AUD';
        const symbol = { AUD: '$', NZD: '$', SGD: '$', GBP: '£', USD: '$' }[currency] || '$';
        shippingMsg.innerHTML = `You're <span class="am-shipping-highlight">${symbol}${remaining.toFixed(2)} ${currency}</span> away from free shipping`;
        const pct = Math.min((subtotal / threshold) * 100, 100);
        shippingFill.style.width = pct + '%';
        shippingFill.classList.remove('is-complete');
      }
    } else {
      if (hasSub) {
        shippingMsg.innerHTML = `You've earned free shipping. <strong>Perfect.</strong>`;
        shippingFill.style.width = '100%';
        shippingFill.classList.add('is-complete');
      } else if (hasOtpOnly) {
        shippingMsg.innerHTML = `Subscribe to unlock <span class="am-shipping-highlight">bonuses and savings</span>`;
        shippingFill.style.width = '0%';
        shippingFill.classList.remove('is-complete');
      }
    }
  }

  function renderUpsell(cartData) {
    if (!upsellSub || !upsellSubBtn || !upsellSubMsg) { return; }
    const productItems = cartData.items.filter(i => isProduct(i.variant_id));
    const otpItemsList = productItems.filter(i => isOneTime(i.variant_id));
    const hasSub = productItems.some(i => isSubscription(i.variant_id));

    if (otpItemsList.length > 0 && !hasSub) {
      const otpItem = otpItemsList[0];
      const subVariantId = CONFIG.otpToSingleSub[otpItem.variant_id];
      if (subVariantId) {
        upsellSubBtn.dataset.otpKey = otpItem.key;
        upsellSubBtn.dataset.otpVariantId = otpItem.variant_id;
        upsellSubBtn.dataset.subVariantId = subVariantId;

        // Show generic message immediately
        upsellSubMsg.textContent = 'Switch to a subscription to save and get a free Welcome Kit.';
        upsellSub.style.display = '';

        // Backfill exact savings amount in background (non-blocking)
        const handle = getProductHandle(otpItem);
        const cached = handle ? productPriceCache[handle] : null;
        if (cached && cached.otpPrice && cached.singleSubPrice && cached.otpPrice > cached.singleSubPrice) {
          const savingsAmount = (cached.otpPrice - cached.singleSubPrice) / 100;
          const currency = window.Shopify?.currency?.active || 'AUD';
          const symbol = { AUD: '$', NZD: '$', SGD: '$', GBP: '£', USD: '$' }[currency] || '$';
          upsellSubMsg.textContent = `Switch to a subscription to save ${symbol}${savingsAmount.toFixed(0)} and get a free Welcome Kit.`;
        } else {
          fetchProductPrices(otpItem).then(prices => {
            if (prices.otpPrice && prices.singleSubPrice && prices.otpPrice > prices.singleSubPrice) {
              const savingsAmount = (prices.otpPrice - prices.singleSubPrice) / 100;
              const currency = window.Shopify?.currency?.active || 'AUD';
              const symbol = { AUD: '$', NZD: '$', SGD: '$', GBP: '£', USD: '$' }[currency] || '$';
              upsellSubMsg.textContent = `Switch to a subscription to save ${symbol}${savingsAmount.toFixed(0)} and get a free Welcome Kit.`;
            }
          }).catch(() => {});
        }
        return;
      }
    }
    upsellSub.style.display = 'none';
  }

  async function handleSwitchToSub() {
    if (isUpdating) return;
    isUpdating = true;

    const otpKey = upsellSubBtn.dataset.otpKey;
    const otpVariantId = parseInt(upsellSubBtn.dataset.otpVariantId);
    const subVariantId = parseInt(upsellSubBtn.dataset.subVariantId);

    // OPTIMISTIC: immediately show the subscription item in place of OTP
    const otpItem = cart.items.find(i => i.key === otpKey);
    if (otpItem) {
      // Save real gift keys before we modify
      const currentRealGifts = cart.items.filter(i => isGift(i.variant_id) && !i.key.startsWith('temp-gift-') && !i.key.startsWith('optimistic-'));
      realGiftKeys = currentRealGifts.map(i => i.key);

      // Replace OTP with sub optimistically
      otpItem.variant_id = subVariantId;
      otpItem.key = 'optimistic-sub-' + Date.now();
      otpItem._optimistic = true;

      // Recompute gifts
      const desiredGifts = computeDesiredGifts(cart.items.filter(i => !isGift(i.variant_id)));
      cart.items = cart.items.filter(i => !isGift(i.variant_id));
      for (const [vid, qty] of Object.entries(desiredGifts)) {
        cart.items.push({
          key: 'temp-gift-' + vid,
          variant_id: parseInt(vid),
          quantity: qty,
          final_price: 0,
          final_line_price: 0,
          original_price: 0,
          original_line_price: 0,
          product_title: 'Free Gift',
          image: null,
          url: '',
          _optimistic: true
        });
      }

      cart.item_count = cart.items.filter(i => !isGift(i.variant_id)).reduce((sum, i) => sum + i.quantity, 0);
      cart.total_price = cart.items.reduce((sum, i) => sum + (i.final_line_price || 0), 0);
      lockCheckout('Updating cart...');
      render(cart);
    }

    try {
      // Single update call: zero OTP + zero old gifts
      const updates = {};
      updates[otpKey] = 0;
      for (const gk of realGiftKeys) {
        updates[gk] = 0;
      }
      realGiftKeys = [];
      await updateCartItems(updates);

// Single add call: sub + correct gift — WITH its selling plan (cart fix)
      const giftId = getGiftForVariant(subVariantId);
      const handleHint = (otpItem && getProductHandle(otpItem)) || 'daily-longevity-blend';
      const sellingPlan = await getSellingPlanForVariant(subVariantId, handleHint);
      const subLine = { id: subVariantId, quantity: 1 };
      if (sellingPlan) subLine.selling_plan = sellingPlan;
      const items = [subLine];
      if (giftId) items.push({ id: giftId, quantity: 1, properties: { '_gift': 'true' } });
      await addToCartApi(items);

      // Use response — just one fetchCart to reconcile
      const finalCart = await fetchCart();
      render(finalCart);
    } catch (err) {
      console.error('[AM Cart] Error switching to sub:', err);
      try {
        const recoveryCart = await fetchCart();
        render(recoveryCart);
      } catch (e) {}
    } finally {
      isUpdating = false;
    }
  }

  /* =========================================
     MAIN RENDER
     ========================================= */

  async function render(cartData) {
    cart = cartData;
    const productItems = cart.items.filter(i => isProduct(i.variant_id));
    const giftItemsList = cart.items.filter(i => isGift(i.variant_id));
    const subProductItems = productItems.filter(i => isSubscription(i.variant_id));
    const otpProductItems = productItems.filter(i => isOneTime(i.variant_id));
    const hasItems = productItems.length > 0;

    emptyEl.style.display = hasItems ? 'none' : '';
    itemsEl.style.display = hasItems ? '' : 'none';
    footerEl.style.display = hasItems ? '' : 'none';

    // Render IMMEDIATELY with cached savings (or 0 if not yet known)
    let savingsMap = {};
    if (subProductItems.length > 0) {
      const handle = getProductHandle(subProductItems[0]);
      const cached = handle ? productPriceCache[handle] : null;
      if (cached && cached.otpPrice) {
        for (const item of subProductItems) {
          const subPricePerUnit = item.final_price;
          let otpEquivalent = cached.otpPrice;
          if (isDoubleSub(item.variant_id)) otpEquivalent = cached.otpPrice * 2;
          if (otpEquivalent > subPricePerUnit) {
            savingsMap[item.variant_id] = Math.floor((1 - subPricePerUnit / otpEquivalent) * 100);
          }
        }
      }
    }

    if (subProductItems.length > 0) {
      subSection.style.display = '';
      subItems.innerHTML = subProductItems.map(i => renderProductItem(i, savingsMap[i.variant_id] || 0)).join('');
    } else {
      subSection.style.display = 'none';
      subItems.innerHTML = '';
    }

    if (otpProductItems.length > 0) {
      otpSection.style.display = '';
      otpItems.innerHTML = otpProductItems.map(i => renderProductItem(i, 0)).join('');
    } else {
      otpSection.style.display = 'none';
      otpItems.innerHTML = '';
    }

    if (giftItemsList.length > 0) {
      giftsSection.style.display = '';
      giftsDivider.style.display = '';
      giftItems.innerHTML = giftItemsList.map(renderGiftItem).join('');
    } else {
      giftsSection.style.display = 'none';
      giftsDivider.style.display = 'none';
      giftItems.innerHTML = '';
    }

    clearWrap.style.display = hasItems ? '' : 'none';

    if (isOptimisticState(cart)) {
      subtotalEl.textContent = '';
      lockCheckout('Adding to cart...');
    } else {
      subtotalEl.textContent = formatMoney(cart.total_price);
      unlockCheckout();
    }

    renderShippingBar(cartData);
    renderUpsell(cartData);
    renderPromo(cartData);
    updateCartCount(cart.item_count);

    // Backfill savings % in background (non-blocking) if not yet cached
    if (subProductItems.length > 0 && Object.keys(savingsMap).length === 0) {
      fetchOneTimePrice(subProductItems[0]).then(otpPrice => {
        if (!otpPrice) return;
        // Re-render just the savings badges without a full render
        for (const item of subProductItems) {
          const subPricePerUnit = item.final_price;
          let otpEquivalent = otpPrice;
          if (isDoubleSub(item.variant_id)) otpEquivalent = otpPrice * 2;
          if (otpEquivalent > subPricePerUnit) {
            const pct = Math.floor((1 - subPricePerUnit / otpEquivalent) * 100);
            const el = document.querySelector(`[data-variant-id="${item.variant_id}"] .am-cart__line-price-row`);
            if (el && !el.querySelector('.am-cart__line-savings')) {
              el.insertAdjacentHTML('beforeend', `<span class="am-cart__line-savings">Saving ${pct}%</span>`);
            }
          }
        }
      }).catch(() => {});
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('cart-count').forEach(el => {
      el.textContent = count;
      el.classList.toggle('opacity-0', count === 0);
    });
    document.querySelectorAll('.count-bubble').forEach(el => {
      el.textContent = count;
      el.classList.toggle('opacity-0', count === 0);
    });
  }

  /* =========================================
     OPTIMISTIC LINE ITEM BUILDER
     - Used when Add to Cart is clicked, so user sees the product
       in the cart BEFORE the API responds
     ========================================= */

  function buildOptimisticItem(variantId, quantity, sellingPlan) {
    // Try to find image/title from the product page if we're on one
    let productTitle = 'Daily Longevity Blend';
    let productImage = null;
    let productHandle = 'daily-longevity-blend';
    let pricePerUnit = 0;

    // Pull from product page if we're on one
    if (window.location.pathname.includes('/products/')) {
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) productTitle = ogTitle.content.split(/\s*[-–—|]\s*/)[0].trim();

      const ogImage = document.querySelector('meta[property="og:image"]');
      if (ogImage) productImage = ogImage.content;

      const handleMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (handleMatch) productHandle = handleMatch[1];

      // Try to get price from page
      const priceEl = document.querySelector('[data-price-cents], .product-price, .price__current');
      if (priceEl?.dataset?.priceCents) {
        pricePerUnit = parseInt(priceEl.dataset.priceCents);
      }
    }

    // Use cached product price if available
    if (!pricePerUnit && isSubscription(variantId)) {
      // Rough estimate from cache
      const handles = Object.keys(productPriceCache);
      if (handles.length > 0) {
        const cached = productPriceCache[handles[0]];
        if (cached.singleSubPrice) {
          pricePerUnit = isDoubleSub(variantId) ? cached.singleSubPrice * 1.8 : cached.singleSubPrice;
        }
      }
    }

    return {
      key: 'optimistic-' + variantId + '-' + Date.now(),
      variant_id: variantId,
      quantity: quantity,
      product_title: productTitle,
      image: productImage,
      url: `/products/${productHandle}`,
      final_price: pricePerUnit,
      final_line_price: pricePerUnit * quantity,
      original_price: pricePerUnit,
      original_line_price: pricePerUnit * quantity,
      selling_plan_allocation: sellingPlan ? { selling_plan: { id: sellingPlan } } : null,
      _optimistic: true
    };
  }

  // Returns true if the cart contains any optimistic (pending) items
  function isOptimisticState(cartData) {
    return cartData && cartData.items && cartData.items.some(i => i._optimistic);
  }

  // Block checkout while cart is syncing — prevents paying for wrong items
  let checkoutOriginalText = null;

  function lockCheckout(message) {
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', preventCheckout, true);
    }
    if (checkoutBtn) {
      if (checkoutOriginalText === null) {
        checkoutOriginalText = checkoutBtn.innerHTML;
      }
      checkoutBtn.style.opacity = '0.5';
      checkoutBtn.style.pointerEvents = 'none';
      if (message) {
        checkoutBtn.innerHTML = '<span style="font-size:17.5px;font-weight:600;">' + message + '</span>';
      }
    }
  }

  function unlockCheckout() {
    if (checkoutForm) {
      checkoutForm.removeEventListener('submit', preventCheckout, true);
    }
    if (checkoutBtn) {
      checkoutBtn.style.opacity = '';
      checkoutBtn.style.pointerEvents = '';
      if (checkoutOriginalText !== null) {
        checkoutBtn.innerHTML = checkoutOriginalText;
        checkoutOriginalText = null;
      }
    }
  }

  function preventCheckout(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  // Checkout-time safety net: never let a subscription line check out without its plan.
  // Fail-open — if it can't heal, it lets checkout proceed (never blocks a real customer).
  async function healAndCheckout(e) {
    if (isUpdating || isOptimisticState(cart)) return;
    if (!cart || !cart.items) return;
    const planless = cart.items.filter(i => isSubscription(i.variant_id) && !i.selling_plan_allocation);
    if (planless.length === 0) return;

    e.preventDefault();
    e.stopPropagation();
    try {
      for (const line of planless) {
        const plan = CONFIG.variantToSellingPlan[line.variant_id];
        if (!plan) continue;
        await updateCartItems({ [line.key]: 0 });
        await addToCartApi([{ id: line.variant_id, quantity: line.quantity, selling_plan: plan }]);
      }
      await fetchCart();
    } catch (err) {
      console.error('[AM Cart] Checkout heal failed (proceeding anyway):', err);
    }
    window.location.href = '/checkout';
  }

  function buildOptimisticGift(variantId) {
    // Pick the right fallback image for this gift type
    let giftImage = CONFIG.fallbackImages.singleKit;
    if (variantId === CONFIG.kits.auEx.double || variantId === CONFIG.kits.nr.double) {
      giftImage = CONFIG.fallbackImages.doubleKit;
    } else if (variantId === CONFIG.shaker) {
      giftImage = CONFIG.fallbackImages.shaker;
    }

    const info = getGiftDisplayInfo(variantId);
    return {
      key: 'optimistic-gift-' + variantId + '-' + Date.now(),
      variant_id: variantId,
      quantity: 1,
      product_title: info.name,
      image: giftImage,
      url: '',
      final_price: 0,
      final_line_price: 0,
      original_price: 0,
      original_line_price: 0,
      _optimistic: true
    };
  }

  /* =========================================
     CART OPERATIONS
     ========================================= */

async function addProductWithGift(variantId, quantity, sellingPlan, properties) {
    // Safety net: a subscription variant must always carry its selling plan
    if (isSubscription(variantId) && !sellingPlan) {
      sellingPlan = await getSellingPlanForVariant(variantId);
    }
    const items = [];
    const productItem = { id: variantId, quantity: quantity };
    if (sellingPlan) productItem.selling_plan = sellingPlan;
    if (properties && Object.keys(properties).length > 0) productItem.properties = properties;
    items.push(productItem);

    if (isSubscription(variantId)) {
      const giftId = getGiftForVariant(variantId);
      if (giftId) items.push({ id: giftId, quantity: 1, properties: { '_gift': 'true' } });
    }

    // SPEED: build optimistic cart and render IMMEDIATELY before API call
    // Prefer the live in-memory cart (most up to date) over the cache
    const startingCart = cart || getCachedCart() || { items: [], item_count: 0, total_price: 0 };
    const optimisticCart = JSON.parse(JSON.stringify(startingCart));

    // Remove all gifts (they'll be recomputed)
    optimisticCart.items = (optimisticCart.items || []).filter(i => !isGift(i.variant_id));

    // Add new product
    optimisticCart.items.push(buildOptimisticItem(variantId, quantity, sellingPlan));

    // Recompute gifts for the new cart
    const desiredGifts = computeDesiredGifts(optimisticCart.items);
    for (const vid of Object.keys(desiredGifts).map(Number)) {
      optimisticCart.items.push(buildOptimisticGift(vid));
    }

    // Recompute totals
    optimisticCart.item_count = optimisticCart.items
      .filter(i => !isGift(i.variant_id))
      .reduce((sum, i) => sum + i.quantity, 0);
    optimisticCart.total_price = optimisticCart.items.reduce((sum, i) => sum + (i.final_line_price || 0), 0);

    // Fire API call immediately (don't wait)
    const addPromise = (async () => {
      await addToCartApi(items);
      return await fetchCart();
    })();

    // Delay drawer open by 1.2s so PDP button animation plays out
    await new Promise(resolve => setTimeout(resolve, 1800));

    // Now open the drawer with optimistic data
    if (!isOpen) {
      isOpen = true;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      body.classList.add('am-cart-open');
    }
    render(optimisticCart);

    // Wait for API to finish and render real data
    try {
      const cartData = await addPromise;
      await render(cartData);

      if (drawerReadyResolve) {
        drawerReadyResolve();
        drawerReadyResolve = null;
      }

      // Lightweight gift correction if needed
      const desired = computeDesiredGifts(cartData.items.filter(i => !isGift(i.variant_id)));
      const currentGifts = {};
      for (const item of cartData.items) {
        if (isGift(item.variant_id)) {
          currentGifts[item.variant_id] = (currentGifts[item.variant_id] || 0) + item.quantity;
        }
      }
      let giftsCorrect = true;
      for (const [vid, qty] of Object.entries(desired)) {
        if ((currentGifts[parseInt(vid)] || 0) !== qty) { giftsCorrect = false; break; }
      }
      for (const vid of Object.keys(currentGifts)) {
        if (!desired[vid]) { giftsCorrect = false; break; }
      }
      if (!giftsCorrect) {
        const giftUpdates = {};
        for (const item of cartData.items) {
          if (isGift(item.variant_id)) giftUpdates[item.key] = 0;
        }
        if (Object.keys(giftUpdates).length > 0) await updateCartItems(giftUpdates);
        const toAdd = [];
        for (const [vid, qty] of Object.entries(desired)) {
          toAdd.push({ id: parseInt(vid), quantity: qty, properties: { '_gift': 'true' } });
        }
        if (toAdd.length > 0) await addToCartApi(toAdd);
        const fixedCart = await fetchCart();
        await render(fixedCart);
      }
    } catch (err) {
      console.error('[AM Cart] Add failed:', err);
      try {
        const recoveryCart = await fetchCart();
        await render(recoveryCart);
      } catch (e) {}
      if (drawerReadyResolve) {
        drawerReadyResolve();
        drawerReadyResolve = null;
      }
    }
  }

  // Optimistic quantity update — unchanged from v7
  const pendingUpdates = {};
  let updateScheduled = false;

  // Store real server-side gift keys so executeServerSync can zero them out
  let realGiftKeys = [];

  async function updateQuantity(key, variantId, newQty) {
    if (!cart) return;
    const safeNewQty = newQty <= 0 ? 0 : newQty;

    const lineItem = cart.items.find(i => i.key === key);
    if (!lineItem) return;
    const pricePerUnit = lineItem.final_price;

    // Save real gift keys BEFORE we replace them with temp keys
    const currentRealGifts = cart.items.filter(i => isGift(i.variant_id) && !i.key.startsWith('temp-gift-') && !i.key.startsWith('optimistic-'));
    if (currentRealGifts.length > 0) {
      realGiftKeys = currentRealGifts.map(i => i.key);
    }

    if (safeNewQty === 0) {
      cart.items = cart.items.filter(i => i.key !== key);
    } else {
      lineItem.quantity = safeNewQty;
      lineItem.final_line_price = pricePerUnit * safeNewQty;
      lineItem.original_line_price = lineItem.original_price * safeNewQty;
    }

    const desiredGifts = computeDesiredGifts(cart.items);
    cart.items = cart.items.filter(i => !isGift(i.variant_id));
    for (const [vid, qty] of Object.entries(desiredGifts)) {
      cart.items.push({
        key: 'temp-gift-' + vid,
        variant_id: parseInt(vid),
        quantity: qty,
        final_price: 0,
        final_line_price: 0,
        original_price: 0,
        original_line_price: 0,
        product_title: 'Free Gift',
        image: null,
        url: ''
      });
    }

    cart.item_count = cart.items.reduce((sum, i) => sum + (isGift(i.variant_id) ? 0 : i.quantity), 0);
    cart.total_price = cart.items.reduce((sum, i) => sum + i.final_line_price, 0);

    // Keep sessionStorage in sync so optimistic add-to-cart doesn't use stale data
    setCachedCart(cart);

    await render(cart);

    pendingUpdates[key] = safeNewQty;
    lockCheckout('Updating cart...');
    scheduleServerSync();
  }

  let syncDebounceTimer = null;
  function scheduleServerSync() {
    if (syncDebounceTimer) clearTimeout(syncDebounceTimer);
    syncDebounceTimer = setTimeout(executeServerSync, 300);
  }

  async function executeServerSync() {
    if (updateScheduled) return;
    updateScheduled = true;

    try {
      const updates = { ...pendingUpdates };
      Object.keys(pendingUpdates).forEach(k => delete pendingUpdates[k]);

      // Use saved real gift keys to zero out server-side gifts
      const serverUpdates = { ...updates };
      for (const giftKey of realGiftKeys) {
        if (!(giftKey in serverUpdates)) {
          serverUpdates[giftKey] = 0;
        }
      }
      // Clear the saved keys after use
      realGiftKeys = [];

      // Single update call: sets product qty + zeros out old gifts
      const updatedCart = await updateCartItems(serverUpdates);

      // Compute desired gifts from the updated cart
      const nonGiftItems = updatedCart.items.filter(i => !isGift(i.variant_id) && isProduct(i.variant_id));
      const desiredGifts = computeDesiredGifts(nonGiftItems);
      const toAdd = [];
      for (const [vid, qty] of Object.entries(desiredGifts)) {
        toAdd.push({ id: parseInt(vid), quantity: qty, properties: { '_gift': 'true' } });
      }

      let finalCart;
      if (toAdd.length > 0) {
        await addToCartApi(toAdd);
        // Need to fetch to get the complete cart with gifts
        finalCart = await fetchCart();
      } else {
        // No gifts needed — updatedCart is already the final state
        finalCart = updatedCart;
        setCachedCart(finalCart);
      }

      if (finalCart.item_count !== cart.item_count || finalCart.total_price !== cart.total_price) {
        await render(finalCart);
      } else {
        cart = finalCart;
      }
    } catch (err) {
      console.error('[AM Cart] Error syncing to server:', err);
      try {
        const recoveryCart = await fetchCart();
        await render(recoveryCart);
      } catch (e) {}
    } finally {
      updateScheduled = false;
      if (Object.keys(pendingUpdates).length > 0) {
        scheduleServerSync();
      } else {
        unlockCheckout();
      }
    }
  }

  async function handleClearAll() {
    if (isUpdating) return;
    isUpdating = true;
    try {
      const clearedCart = await clearCartApi();
      // Clear the sessionStorage cache so stale items don't reappear
      try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
      setCachedCart(clearedCart);
      await render(clearedCart);
    } catch (err) {
      console.error('[AM Cart] Error clearing cart:', err);
    } finally {
      isUpdating = false;
    }
  }

  function canIncrease(variantId) {
    if (!cart) return false;
    const productItems = cart.items.filter(i => !isGift(i.variant_id));
    const lineItem = productItems.find(i => i.variant_id === variantId);
    const currentQty = lineItem ? lineItem.quantity : 0;
    if (currentQty >= getMaxQty(variantId)) return false;

    if (isSubscription(variantId)) {
      let totalServings = 0;
      for (const item of productItems) {
        if (isSingleSub(item.variant_id)) totalServings += item.quantity;
        if (isDoubleSub(item.variant_id)) totalServings += item.quantity * 2;
      }
      const addedServings = isDoubleSub(variantId) ? 2 : 1;
      if (totalServings + addedServings > CONFIG.maxTotalSub) return false;
    }
    return true;
  }

  /* =========================================
     OPEN / CLOSE
     ========================================= */

function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    // Lock body scroll position (iOS-safe)
    const scrollY = window.scrollY;
    body.style.setProperty('--am-scroll-y', `-${scrollY}px`);
    body.dataset.scrollY = scrollY;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    body.classList.add('am-cart-open');

    // SPEED: render from cache instantly, then refresh from server
    const cached = getCachedCart();
    if (cached && cached.items && cached.items.length > 0) {
      render(cached);
    }
    refreshCart();
  }

function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    body.classList.remove('am-cart-open');
    // Restore scroll position
    const scrollY = parseInt(body.dataset.scrollY || '0');
    body.style.removeProperty('--am-scroll-y');
    delete body.dataset.scrollY;
    window.scrollTo(0, scrollY);
    if (cart) updateCartCount(cart.item_count);
  }

  async function refreshCart() {
    try {
      const cartData = await fetchCart();
      await render(cartData);

      // Only sync gifts if they look wrong (avoids 4 extra API calls when gifts are fine)
      const desired = computeDesiredGifts(cartData.items.filter(i => !isGift(i.variant_id)));
      const currentGifts = {};
      for (const item of cartData.items) {
        if (isGift(item.variant_id)) {
          currentGifts[item.variant_id] = (currentGifts[item.variant_id] || 0) + item.quantity;
        }
      }
      let giftsCorrect = true;
      for (const [vid, qty] of Object.entries(desired)) {
        if ((currentGifts[parseInt(vid)] || 0) !== qty) { giftsCorrect = false; break; }
      }
      for (const vid of Object.keys(currentGifts)) {
        if (!desired[vid]) { giftsCorrect = false; break; }
      }

      if (!giftsCorrect) {
        const giftResult = await syncGifts(cartData);
        if (giftResult) await render(giftResult);
      }
    } catch (err) {
      console.error('[AM Cart] Error refreshing cart:', err);
    }
  }

  /* =========================================
     EVENT LISTENERS & INTERCEPTION (unchanged)
     ========================================= */

  function init() {
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    continueBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let isSwiping = false;

    drawer.addEventListener('touchstart', (e) => {
      if (!isOpen) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchCurrentX = touchStartX;
      isSwiping = false;
    }, { passive: true });

    drawer.addEventListener('touchmove', (e) => {
      if (!isOpen) return;
      touchCurrentX = e.touches[0].clientX;
      const deltaX = touchCurrentX - touchStartX;
      const deltaY = Math.abs(e.touches[0].clientY - touchStartY);

      if (!isSwiping && deltaX > 10 && deltaX > deltaY) {
        isSwiping = true;
      }

      if (isSwiping && deltaX > 0) {
        drawer.style.transform = `translateX(${deltaX}px)`;
        drawer.style.transition = 'none';
      }
    }, { passive: true });

    drawer.addEventListener('touchend', () => {
      if (!isSwiping) return;
      const deltaX = touchCurrentX - touchStartX;
      drawer.style.transition = '';
      drawer.style.transform = '';

      if (deltaX > 80) {
        closeDrawer();
      }
      isSwiping = false;
    });

    clearBtn.addEventListener('click', handleClearAll);
    upsellSubBtn.addEventListener('click', handleSwitchToSub);
    if (checkoutForm) checkoutForm.addEventListener('submit', healAndCheckout, true);


    document.getElementById('am-cart-body').addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      const action = btn.dataset.action;
      const key = btn.dataset.key;
      const variantId = parseInt(btn.dataset.variantId);
      const item = cart.items.find(i => i.key === key);
      if (!item) return;

      if (action === 'remove') updateQuantity(key, variantId, 0);
      else if (action === 'decrease') updateQuantity(key, variantId, item.quantity - 1);
      else if (action === 'increase' && canIncrease(variantId)) {
        updateQuantity(key, variantId, item.quantity + 1);
      }
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest(
        '.js-cart-trigger, [aria-controls="cart-drawer"], a[href="/cart"], a[href$="/cart"]'
      );
      if (trigger) {
        if (trigger.closest('form[action="/cart"]')) return;
        if (trigger.closest('#am-cart-checkout-form')) return;
        if (trigger.textContent.trim().toLowerCase().includes('view cart')) return;
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      }
    }, true);

    interceptAddToCart();

    fetchCart().then(cartData => {
      cart = cartData;
      updateCartCount(cartData.item_count);
      // Pre-warm the product price cache so savings % is instant on first open
      const firstProduct = cartData.items.find(i => isProduct(i.variant_id));
      if (firstProduct) fetchProductPrices(firstProduct).catch(() => {});
    });

    // Also pre-warm if we're on a product page
    if (window.location.pathname.includes('/products/')) {
      const handle = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (handle) {
        fetch(`/products/${handle[1]}.js`).then(r => r.json()).then(product => {
          let otpPrice = null, singleSubPrice = null;
          for (const v of product.variants) {
            if (CONFIG.oneTime.includes(v.id)) otpPrice = v.price;
            if (CONFIG.singleSub.includes(v.id)) singleSubPrice = v.price;
          }
          productPriceCache[handle[1]] = { otpPrice, singleSubPrice };
        }).catch(() => {});
      }
    }
  }

  function interceptAddToCart() {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');

      if (url.includes('/cart/add') && !addingFromUs) {
        const options = args[1] || {};
        let bodyData = null;

        try {
          if (options.body) {
            if (typeof options.body === 'string') {
              bodyData = JSON.parse(options.body);
            } else if (options.body instanceof FormData) {
              bodyData = { id: options.body.get('id'), quantity: options.body.get('quantity') };
              const sp = options.body.get('selling_plan');
              if (sp) bodyData.selling_plan = sp;
            }
          }
        } catch (e) {}

        if (bodyData) {
          const variantId = parseInt(bodyData.id || bodyData.items?.[0]?.id);
          const quantity = parseInt(bodyData.quantity || bodyData.items?.[0]?.quantity || 1);
          const sellingPlan = bodyData.selling_plan || bodyData.items?.[0]?.selling_plan || null;
          const properties = bodyData.properties || bodyData.items?.[0]?.properties || {};

          if (variantId && !isNaN(variantId)) {
            addProductWithGift(variantId, quantity, sellingPlan, properties);

            return new Promise(resolve => {
              drawerReadyResolve = () => {
                resolve(new Response(JSON.stringify({
                  items: [{ id: variantId, quantity: quantity, title: 'Product', variant_id: variantId }]
                }), {
                  status: 200,
                  headers: { 'Content-Type': 'application/json' }
                }));
              };
              setTimeout(() => {
                if (drawerReadyResolve) {
                  drawerReadyResolve();
                  drawerReadyResolve = null;
                }
              }, 8000);
            });
          }
        }
      }

      // Block Shopify theme's section rendering requests (saves ~1.4s per cart change)
      if (url.includes('sections=') && url.includes('cart')) {
        return Promise.resolve(new Response('{}', {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }

      return originalFetch.apply(this, args);
    };

    const nativeDrawer = document.querySelector('cart-drawer, #cart-drawer');
    if (nativeDrawer) {
      nativeDrawer.style.display = 'none';
      const obs = new MutationObserver(() => {
        if (nativeDrawer.hasAttribute('open') ||
            nativeDrawer.className.match(/is-open|is-visible|active/)) {
          nativeDrawer.removeAttribute('open');
          nativeDrawer.classList.remove('is-open', 'is-visible', 'active');
          nativeDrawer.style.display = 'none';
        }
      });
      obs.observe(nativeDrawer, { attributes: true });
    }
  }

  /* =========================================
     BOOT
     ========================================= */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AMCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };
})();